import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { TreeView, TreeViewNode, TreeViewOptions, TreeViewEventData } from '../../Widgets/TreeView';
import { ModalApi } from '../../Widgets/Modal';
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';
import { FileUtils } from '../../Utils/FileUtils';
import { UriHelper } from '../../Utils/UriHelper';

export interface SettingsPageOptions extends PageOptionsBase {
    urlGameList: string;
}

export class SettingsPage extends PageBase<SettingsPageOptions> {
    private _treeCustomers: TreeView;
    private _treeGames: TreeView;
    private _elemSelectAllCustomerTree: JQuery;
    private _elemSelectAllGamesTree: JQuery;
    private _gameListModal: ModalApi;
    private _isInitLoad: boolean;
    private _urlGameList: string;

    constructor(options: SettingsPageOptions) {
        super(options);

        this.handleCustomerTreeInit = this.handleCustomerTreeInit.bind(this);
        this.handleCustomerTreeRenderNode = this.handleCustomerTreeRenderNode.bind(this);
        this.handleCustomerTreeGetIcon = this.handleCustomerTreeGetIcon.bind(this);
        this.handleCustomerTreeAcceptSelection = this.handleCustomerTreeAcceptSelection.bind(this);
        this.handleCustomerTreeSelectAll = this.handleCustomerTreeSelectAll.bind(this);

        this.handleGamesTreeRenderNode = this.handleGamesTreeRenderNode.bind(this);
        this.handleGamesTreeGetIcon = this.handleGamesTreeGetIcon.bind(this);
        this.handleGamesTreeSelectAll = this.handleGamesTreeSelectAll.bind(this);

        this.handleGameListInfoClick = this.handleGameListInfoClick.bind(this);

        this._urlGameList = this._options.urlGameList;
    }

    init(): void {
        this._isInitLoad = true;
        this._elemSelectAllCustomerTree = $('#chSelectAllCustomerTree');
        this._elemSelectAllCustomerTree.on('change', this.handleCustomerTreeSelectAll);

        this._elemSelectAllGamesTree = $('#chSelectAllGames');
        this._elemSelectAllGamesTree.on('change', this.handleGamesTreeSelectAll);

        this._gameListModal = new ModalApi('gameListModal');

        this._treeCustomers = TreeView.get('treeCustomers');
        this._treeCustomers.onInit = this.handleCustomerTreeInit;
        this._treeCustomers.onRenderNode = this.handleCustomerTreeRenderNode;
        this._treeCustomers.onAcceptSelection = this.handleCustomerTreeAcceptSelection;
        this._treeCustomers.options.icon = this.handleCustomerTreeGetIcon;
        this._treeCustomers.initialize();

        this._treeGames = TreeView.get('treeGames');
        this._treeGames.onRenderNode = this.handleGamesTreeRenderNode;
        this._treeGames.options.icon = this.handleGamesTreeGetIcon;
        this._treeGames.initialize();
        this._isInitLoad = false;
    }

    // 'Customer tree' methods
    private handleCustomerTreeInit(event: JQueryEventObject, data: TreeViewEventData): void {
        this._treeCustomers.collapseAll();
    }

    private handleCustomerTreeRenderNode(event: JQueryEventObject, data: TreeViewEventData): void {
        var node = data.node.fancyNode;
        var metadata = node.data.metadata;

        let isCurrency = metadata.type === 'Currency';
        if (isCurrency) {
            let unselectable = (node as any).unselectable;
            let style = 'color: cadetblue; padding-left: 5px; cursor: pointer;';
            var node_span = $((node as any).span);
            if (this._isInitLoad) {
                var info_span = $(`<span class="glyphicon glyphicon-info-sign" data-key='${node.key}' style='${style}' title='Show game list info...'></span>`);
                info_span.on('click', this.handleGameListInfoClick);
                info_span.appendTo(node_span);
            }
        }

        if (metadata.status === 'Closed') {
            TreeView.updateNodeStrikeThrough(node, true);
            return;
        }

        if (metadata.isDefined === false && metadata.status !== 'Closed') {
            TreeView.updateNodeDisabled(node, true);
            return;
        }
    }

    private handleCustomerTreeAcceptSelection(node: TreeViewNode): boolean {
        // get only 'currency' selected nodes
        return node.fancyNode.data.metadata.type === 'Currency';
    }

    private handleCustomerTreeGetIcon(event: { type: string }, data: { node: Fancytree.FancytreeNode }): string {
        if (event.type === 'icon') {
            var type = data.node.data.metadata.type;
            var status = data.node.data.metadata.status;
            var isDisabled = status === 'Disabled';

            if (type === 'Customer') {
                return 'fa fa-folder-open';
            } else if (type === 'Operation') {
                return 'fa fa-barcode';
            } else if (type === 'Currency') {
                return 'fa ' + (isDisabled ? 'fa-exclamation' : 'fa-file-o');
            }
        }

        return undefined;
    }

    private handleCustomerTreeSelectAll(): void {
        var selectAll = this._elemSelectAllCustomerTree.is(':checked');

        this._treeCustomers.visit(node => {
            let isCurrency = node.data.metadata.type === 'Currency';
            if (isCurrency) {
                node.setSelected(selectAll);
            }
        });
    }


    // 'Games tree' methods
    private handleGamesTreeRenderNode(event: JQueryEventObject, data: TreeViewEventData): void {
        var node = data.node.fancyNode;
        var metadata = node.data.metadata;

        if (metadata.isDefined === false) {
            TreeView.updateNodeDisabled(node, true);
            return;
        }
    }

    private handleGameListInfoClick(e: JQueryEventObject): void {
        let nodeKey = $(e.target).attr('data-key');
        this.showGameListModal(nodeKey);
    }

    private handleGamesTreeGetIcon(event: { type: string }, data: { node: Fancytree.FancytreeNode }): string {
        if (event.type === 'icon') {
            return 'fa fa-gamepad';
        }

        return undefined;
    }

    private handleGamesTreeSelectAll(): void {
        var selectAll = this._elemSelectAllGamesTree.is(':checked');
        this._treeGames.selectAll(selectAll);
    }

    private showGameListModal(nodeKey: string): void {
        let self = this;
        let keyValues = nodeKey.split('-');
        let urlData = {
            customerCode: keyValues[0],
            currencyCode: keyValues[1]
        };
        let url = UriHelper.setQueryString(this._urlGameList, urlData);

        function updateModalBody(entries: FreeRoundGameListEntry[]) {
            let currencyNode = self._treeCustomers.getNodeByKey(nodeKey);
            let operationNode = currencyNode.parent;
            let customerNode = operationNode.parent;

            let info: FreeRoundTreeEntityInfo = {
                customerCode: `${customerNode.title} (${urlData.customerCode})`,
                currencyCode: `${currencyNode.title} (${urlData.currencyCode})`
            };

            let html = FreeRoundGameList.render(info, entries);
            self._gameListModal.updateBody(html);
            self._gameListModal.show();
        }

        this._gameListModal.hide();
        FileUtils.jsonPost<FreeRoundGameListEntry[]>(url)
            .then(json => {
                if (json) {
                    updateModalBody(json);
                }
            })
            .catch(err => {
                alert('Failed to get data');
                console.error(err);
            });
    }
}

type FreeRoundGameListEntry = {
    GameName: string;
    GameCode: string;
};

type FreeRoundTreeEntityInfo = {
    customerCode: string;
    currencyCode: string;
}

class FreeRoundGameList {
    public static render(info: FreeRoundTreeEntityInfo, entries: FreeRoundGameListEntry[]): string {
        let hasEntries = entries && _.isArray(entries) && entries.length > 0;

        let infoHtml = FreeRoundGameList.renderInfo(info);

        let content = $('<div/>', { style: 'height: 300px; overflow-y: auto; overflow-x: hidden;' });

        if (hasEntries) {
            FreeRoundGameList.renderListHeader(content);

            _.each(entries, entry => {
                FreeRoundGameList.renderListRow(content, entry);
            });
        } else {
            content.append('<b>Game list is empty.</b>');
        }

        return infoHtml + content.prop('outerHTML');
    }

    private static renderInfo(info: FreeRoundTreeEntityInfo): string {
        return $('<div/>').append(
            $(`<div class="row">
                    <div class="col-md-2"><b>Customer:</b></div><div class="col-md-10">${info.customerCode}</div>
               </div>
                <div class="row">
                    <div class="col-md-2"><b>Currency:</b></div><div class="col-md-10">${info.currencyCode}</div>
               </div>
                <p></p>`)).html();
    }

    private static renderListHeader(parent: JQuery) {
        parent.append(
            $(`<div class="row" style="background-color: silver; padding: 2px; font-weight: bold;">
                    <div class="col-md-4">Game name</div>
                    <div class="col-md-4">Game code</div>
               </div>`));
    }

    private static renderListRow(parent: JQuery, entry: FreeRoundGameListEntry) {
        parent.append(
            $(`<div class="row" style="padding: 2px;">
                    <div class="col-md-4">${entry.GameName}</div>
                    <div class="col-md-4">${entry.GameCode}</div>
               </div>`));
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundConfigurationImport/SettingsPage.ts
 **/